const pmeta = {
  "pmeta.min": "Min.",
  "pmeta.anes_local": "Lokalanästhesie",
  "pmeta.anes_general": "Vollnarkose",
  "pmeta.anes_none": "Keine",
  "pmeta.sessions_1": "1 Termin",
  "pmeta.sessions_2": "2 Termine",
  "pmeta.sessions_1_2": "1–2 Termine",
  "pmeta.sessions_2_3": "2–3 Termine",
  "pmeta.sessions_ongoing": "Laufend",
};

export default pmeta;
